import React from "react";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as Variable from "./Variable/v";

import maatregelenSvg from "../../../../content/images/table/XMLID_3_.svg";
import $ from "jquery";
import * as CommonFunctions from "./functions/commonFunctions";
import ColumnList from "../../../common/componet-jsons/column-list-mm.json";
import * as GC from "../../../common/common";
import { CONSTS } from "../../../common/const";
import {GetFreeFormatByIdActionForUser} from "../../../../api/omnimap/omnimapActions";
import {getUserProfile} from "../../../common/common";
import {DropFromSetSelectedButtonIdsIfSelected, MergeUniquely} from "../../../common/function/functions";
import {GetSelected, SetSelected} from "../../../common/tableHandler/manipulateTable";

class Table extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnList: [],
      columnListPure: [],
      columnOrderIdentification: "",
      columnOrderReference: "",
    };
  }

  reloadData(page_number, ids, short_type, direction, field, content = []) {
    var model;
    if (!short_type) {
      if (ids && ids.length) {
        model = {
          content: content,
          context: [
            {
              role: "Beheereenheid zit in folder",
              instance_identifiers: ids,
              direction: "from",
              and_or: "AND",
              start: "2020-11-09T09:56:22.986Z",
            },
          ],
          sorting: [],
          definitions: [process.env.REACT_APP_USER_OBLIGATIONS],
        };
      } else {
        model = {
          content: content,
          definitions: [process.env.REACT_APP_USER_OBLIGATIONS],
          sorting: [],
        };
        window.$mm_obligations_result = [];
      }
    } else if (short_type) {
      if (ids && ids.length) {
        model = {
          content: content,
          context: [
            {
              role: "Beheereenheid zit in folder",
              instance_identifiers: ids,
              direction: "from",
              and_or: "AND",
              start: "2020-11-09T09:56:22.986Z",
            },
          ],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
          definitions: [process.env.REACT_APP_USER_OBLIGATIONS],
        };
      } else {
        model = {
          content: content,
          definitions: [process.env.REACT_APP_USER_OBLIGATIONS],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
        };
      }
    }
    window.$mm_obligations_lastUsedTableFilter = model;
    this.fillTable(model, page_number).then(()=>{
      this.fillFilterColumns();
    });
  }
  fillFilterColumns() {
    var that = this;
    var model = {
      definitions: [process.env.REACT_APP_USER_OBLIGATIONS],
    };
    $.each(window.$mm_obligations_columnList, function (index, data) {
      if (data.id !== "" && data.filter === true) {
        omnimap
          .FillFilterColumnsAction(
            model,
            data.id,
            window.$mm_management_units_token
          )
          .then((result) => {
            CallBackFunctions.FillFilterColumnsCallBack(data, result);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }
  async fillTable(model, page_number, customResult) {
    var that = this;
    window.$mm_obligations_lastUsedTableFilter = model;

    window.$mm_obligations_treeChangeStatus = false;
    window.$mm_obligations_scroll_change = false;

    let result

    if (customResult && typeof customResult === 'object'){
      result = customResult
    } else {
      result  = await omnimap.FillTableAction(
          model,
          page_number,
          window.$mm_management_units_token
      );
    }

    CallBackFunctions.FillTableCallBack(
        result,
        page_number,
        window.$mm_obligations_columnListPure
    );
  }

  addContentAndFillTable(key, value) {
    var hasRow = $.grep(window.$mm_obligations_filterContent, function (v) {
      return v.key === key;
    });
    if (hasRow.length > 0) {
      window.$mm_obligations_filterContent = $.grep(
        window.$mm_obligations_filterContent,
        function (value) {
          return value !== hasRow[0];
        }
      );
    }
    if (value !== null) {
      var values = [];
      values.push(value);
      var contentModel = {
        and_or: "AND",
        datatype: "STRING",
        key: key,
        values: values,
      };
      window.$mm_obligations_filterContent.push(contentModel);
    }

    this.reloadData(
      1,
      window.$mm_obligations_result,
      null,
      null,
      null,
      window.$mm_obligations_filterContent
    );
  }
  searchFilterColumns(key, searchId) {
    var that = this;
    var model = {
      definitions: [process.env.REACT_APP_USER_OBLIGATIONS],
    };

    omnimap
      .SearchFilterColumnsAction(
        model,
        key,
        searchId,
        window.$mm_management_units_token
      )
      .then((result) => {
        CallBackFunctions.SearchFilterColumnsCallBack(searchId, result);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  GetActionsOfRow(rowIds) {
    omnimap
      .GetActionsOfRowAction(rowIds, window.$mm_management_units_token)
      .then(CallBackFunctions.GetActionsOfRowCallback)
      .catch((error) => {
        console.log(error);
      });
  }

  /*** ---PROPSTAN GELEN TREE VERİSİ İÇERİSİNDE TIKLANAN Lİ'NİN TÜM ALT DALLARINDAKİ İDLERİ GETİRİR--- ***/
  treeParser = (data, beheereenheid) => {
    const that = this;
    data.forEach(function (element) {
      if (element.parentfolder === beheereenheid) {
        window.$mm_obligations_result.push(element.id);
        if (element.children.length > 0) {
          that.treeParser(element.children, element.id);
        }
      } else if (element.children && element.children.length > 0) {
        that.treeParser(element.children, beheereenheid);
      }
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const that = this;
    if (!that.props.location.state) {
      if (that.props.location.isDidUpdate !== prevProps.location.isDidUpdate) {
        var model = {
          content: [],
          definitions: [process.env.REACT_APP_USER_OBLIGATIONS],
        };
        // that.setState({ lastUsedTableFilter: model });
        window.$mm_obligations_lastUsedTableFilter = model;

        that.reloadData(1);
        document.getElementById("tree-parent-id").setAttribute("value", "");

        var treeClass = document.querySelector(".tree li.open.act");
        var treeDivClass = document.querySelector(".tree li div.open.act");
        if (treeClass !== null) {
          treeClass.removeAttribute("class");
        }
        if (treeDivClass !== null) {
          treeDivClass.classList.remove("open");
          treeDivClass.classList.remove("act");
        }
      } else {
        $("#cover-spin").hide(0);
      }
    } else if (that.props.location.state && prevProps.location.state) {
      if (
        that.props.location.state.isDidUpdate !==
        prevProps.location.state.isDidUpdate
      ) {
        if (that.props.location.state.isDidUpdate == "0038") {
          var model = {
            content: [],
            definitions: [process.env.REACT_APP_USER_OBLIGATIONS],
          };
          // that.setState({ lastUsedTableFilter: model });
          that.reloadData(1);
        } else {
          window.$mm_obligations_result = [];
          window.$mm_obligations_result.push(that.props.location.state.id);
          this.treeParser(
            that.props.location.state.TreeList,
            that.props.location.state.id
          );
          if (that.props.location.state.treeLocation !== "modal") {
            that.reloadData(1, window.$mm_obligations_result);
          }
        }
      }
      //* sayfa f5 ile yenilendiğinde prev props:
      //* temizlenmediğinden dolayı veri gelmemesi sorunu için bu kod çalıştırılıyor.
      else if (window.performance) {
        if (performance.navigation.type == 1) {
          if (that.props.location.state.isDidUpdate == "0038") {
            var model = {
              content: [],
              definitions: [process.env.REACT_APP_USER_OBLIGATIONS],
            };
            // that.setState({ lastUsedTableFilter: model });
            that.reloadData(1);
          } else {
            window.$mm_obligations_result = [];
            window.$mm_obligations_result.push(that.props.location.state.id);
            this.treeParser(
              that.props.location.state.TreeList,
              that.props.location.state.id
            );
            if (that.props.location.state.treeLocation !== "modal") {
              that.reloadData(1, window.$mm_obligations_result);
            }
          }
        } else {
          alert("This page is not reloaded");
        }
      }
    } else {
      window.$mm_obligations_result = [];
      window.$mm_obligations_result.push(that.props.location.state.id);
      this.treeParser(
        that.props.location.state.TreeList,
        that.props.location.state.id
      );
      if (that.props.location.state.treeLocation !== "modal") {
        that.reloadData(1, window.$mm_obligations_result);
      }
      $("#cover-spin").hide(0);
    }
  }

  handleShowSelectedButton() {
    window.$set_selected_button_selected_ids = [];
    window.$mm_setShowSelectedButtonOff();

    window.$mm_setShowSelectedButtonOnClick = () => {
      const selected = GetSelected();
      window.$set_selected_button_selected_ids = MergeUniquely(window.$set_selected_button_selected_ids, selected)

      if (!window.$mm_setShowSelectedButtonToggleState){
        window.$mm_obligations_lastUsedTableFilter.instance_identifications = [];
      } else {
        window.$mm_obligations_lastUsedTableFilter.instance_identifications = window.$set_selected_button_selected_ids;
      }

      this.fillTable(window.$mm_obligations_lastUsedTableFilter,
          1,
          window.$set_selected_button_selected_ids.length === 0 && window.$mm_setShowSelectedButtonToggleState? CONSTS.EMPTY_TABLE_RESPONSE: null).then(()=>{
        SetSelected(window.$set_selected_button_selected_ids)
      });
    }
  }
  async componentDidMount() {
    const that = this;
    this.handleShowSelectedButton();

    let tableHeaderItems;
    const user = getUserProfile();
    const userID = user.data.identification
    let userColumnResult = await omnimap.GetFreeFormatByIdActionForUserColumnOrder(
        userID,
        CONSTS.COLUMN_ORDER_MM_OBLIGATIONS
    );

      // bu sayfanın column sort'u var mı? userda
      if (userColumnResult.result.status !== "OK") {

        const model = Object.assign({} ,window.$mm_obligations_units_column_order_post_model);
        model.reference = userID;
        model.client_identification = CONSTS.COLUMN_ORDER_MM_OBLIGATIONS;

        omnimap
          .GetFreeFormatAction(
            "",
            "POST",
              model
          )
          .then(() => {
            window.location.reload();
          });
      }

    let result = userColumnResult.data.data.table_sorting[0]
        await this.setState({
          columnOrderIdentification: userColumnResult.data.identification,
          columnOrderReference: userColumnResult.data.reference,
        });


        tableHeaderItems = await result.column_list.map((item, index) =>
          item === "checkbox" ? (
            <th className="sorting_disabled">
              <span className="checkAll" />
              <span className="checkNone" style={{ display: "none" }} />
            </th>
          ) : item === "active" ? (
            <th className="sorting_disabled" style={{ width: "1%" }}>
              <img
                className="icon-table"
                src={maatregelenSvg}
                width={18}
                height={18}
              />
            </th>
          ) : (
            <th key={item}>{item}</th>
          )
        );
        await this.setState({
          columnList: tableHeaderItems,
        });
        window.$mm_obligations_columnListPure = result;

    //}
    /***************************************************************************************/

    if (window.$mm_management_units_token == null) {
      window.$mm_management_units_token = GC.GetToken().then((token) => {
        window.$mm_management_units_token = token;
        this.reloadData(1);
      });
    } else that.reloadData(1);

    ColumnList.forEach(function (item) {
      if (item.name == "mm>obligations") {
        window.$mm_obligations_columnList = item["column-list"];
      }
    });
    var table = $("#example").DataTable({
      order: [],
      ordering: false,
      orderCellsTop: true,
      fixedHeader: true,
      searching: false,
      paging: false,

      scrollX: true, //"500px",
      scrollY: "calc(100vh - 330px)",

      scrollCollapse: true,

      dom: '<"top"if>t<"bottom"pr><"clear">',
      info: true,
      destroy: true,
      infoCallback: function (settings, start, end, max, total, pre) {
        return (
          '<span class="select-item"></span>' +
          '<span class="total_right"><span id="total-rows" class="total">' +
          end +
          "</span> geselecteerd </span>"
        );
      },
      language: {
        paginate: {
          previous: "Eerste",
          next: "Laatste",
        },
        select: {
          rows: '<span class="items">%d </span>items van&nbsp;', //'<span class="items">%d </span>items van&nbsp;',
        },
      },
      columnDefs: [
        {
          targets: 0,
          data: null,
          defaultContent: "",
          orderable: false,
          className: "select-checkbox",
        },
      ],
      select: {
        style: "multi+shift",
        selector: "tr",
      },
      // Disable sorting on the sorting_disabled class
      aoColumnDefs: [
        {
          bSortable: false,
          aTargets: ["sorting_disabled"],
        },
      ],
      colReorder: {
        fixedColumnsLeft: 1
      },
      stateSave: true,
      stateSaveCallback: (settings, data) => {
        let result = CallBackFunctions.TableColumnChangeHandler(
          settings,
          data,
          that.state.columnOrderIdentification,
          that.state.columnOrderReference,
          CONSTS.COLUMN_ORDER_MM_OBLIGATIONS
        );
        window.$mm_obligations_columnListPure = result;
      },
    });
    table.columns().iterator("column", function (ctx, idx) {
      if (
        window.$mm_obligations_columnListPure.column_list[idx] === "checkbox" ||
        window.$mm_obligations_columnListPure.column_list[idx] === "active"
      ) {
      } else {
        $(table.column(idx).header()).append('<span class="sort-icon"/>');
      }
    });
    var lastScrollLeft = 0;
    var lastScrollControl = 0.33;
    var buffer = 0.33; // # of pixels from bottom of scroll to fire your function. Can be 0

    $(".dataTables_scrollBody").scroll(function () {
      var documentScrollLeft = $(".dataTables_scrollBody").scrollLeft();
      if (window.$mm_obligations_scroll_change) {
        if (
          $(".dataTables_scrollBody").prop("scrollHeight") -
            $(".dataTables_scrollBody").scrollTop() <=
          $(".dataTables_scrollBody").height() + buffer
        ) {
          lastScrollControl = 0;
        }
      }
      if (window.$mm_obligations_scroll_change) {
        if (
          $(".dataTables_scrollBody").prop("scrollHeight") -
            $(".dataTables_scrollBody").scrollTop() <=
          $(".dataTables_scrollBody").height() + buffer
        ) {
          lastScrollControl = 0;
        }
      }
      if (lastScrollLeft == documentScrollLeft + lastScrollControl) {
        if (window.$mm_obligations_scroll_change) {
          if (
            $(".dataTables_scrollBody").prop("scrollHeight") -
              $(".dataTables_scrollBody").scrollTop() <=
            $(".dataTables_scrollBody").height() + buffer
          ) {
            if (document.getElementById("tableSide").className !== "d-none") {
              if (
                `/${this.baseURI.split("/")[3]}/${
                  this.baseURI.split("/")[4]
                }` === that.props.location.pathname &&
                window.$mm_obligations_table_total_row_count >
                  process.env.REACT_APP_TABLE_TOTAL_ROW_COUNT
              ) {
                $("#cover-spin").show(0);
                window.$mm_obligations_page_number++;
                that.fillTable(
                  window.$mm_obligations_lastUsedTableFilter,
                  window.$mm_obligations_page_number
                );
              }
            } else window.$mm_obligations_scroll_change = true;
          }
        }
      }
    });
    $(document).on("click", "#mappen_beheren", function () {
      $("#mappen_beheren_modal").modal("show");
    });
    /*** SETUP - ADD A TEXT INPUT TO EACH FOOTER CELL ***/
    $("#example thead tr").clone(true).appendTo("#example thead");
    $("#example thead tr th").removeClass("sorting_asc");

    $(table.table().header()).addClass("scrollabe-datatable");

    document.getElementsByClassName("scrollabe-datatable")[0].parentElement.id =
      "scrollabe-datatable-id";

    $("#scrollabe-datatable-id thead tr")
      .clone(true)
      .appendTo("#scrollabe-datatable-id thead");

    $("#scrollabe-datatable-id thead tr:eq(1) th").each(function (i) {
      var title = $(this).text();
      if (title) {
        var row = $.grep(window.$mm_obligations_columnList, function (v) {
          return String(v.name).toLowerCase() === String(title).toLowerCase();
        });
        var rowId = row[0].id;
        if (row[0].filter == true) {
          $(this).html(
            '<input type="search" class="col-search" id="' + rowId + '" />'
          );
          $("input", this).on("keyup change", function () {
            if (table.column(i).search() !== this.value) {
              table.column(i).search(this.value).draw();
            }
          });
        } else {
          $(this).html("");
        }
      } else if (this.innerHTML.includes("checkAll")) {
        //$(this).html( '<div class="popup threedots" onclick="Popup()"><span class="popuptext" id="myPopup"><a class="maatregelen" href="#">Maatregelen</a><a class="locate" href="#">Beheer gebieden</a><a class="map" href="#">Toon op kaart</a><a class="trash-bin" href="#">Verwijderen</a></span></div>' );
        $(this).html(
          '<div class="popup threedots"><span class="popuptext" id="myPopup"></span></div>'
        );
      } else if (this.innerHTML.includes("bfc3e97d")) {
        $(this).html(
          '<div class="refresh"> </div>' +
            /**popup filter1 */
            '<div class="filter-popup">' +
            '  <span class="popuptext" id="beheer-short-table-popup" ></span>' +
            "</div>"
        );
      } else {
        $(this).html("");
      }
      // if (i > 1) {
      //   var title = $(this).text();
      //   var row = $.grep(window.$mm_obligations_columnList, function (v) {
      //     return v.row === i;
      //   });
      //   var rowId = row[0].id;
      //   if (row[0].filter === true) {
      //     $(this).html(
      //       '<input type="search" class="col-search" id="' + rowId + '" />'
      //     );
      //     $("input", this).on("keyup change", function () {
      //       if (table.column(i).search() !== this.value) {
      //         table.column(i).search(this.value).draw();
      //       }
      //     });
      //   } else {
      //     $(this).html("");
      //   }
      // } else if (i === 0) {
      //   $(this).html(
      //     //$(this).html( '<div class="popup threedots" onclick="Popup()"><span class="popuptext" id="myPopup"><a class="maatregelen" href="#">Maatregelen</a><a class="locate" href="#">Beheer gebieden</a><a class="map" href="#">Toon op kaart</a><a class="trash-bin" href="#">Verwijderen</a></span></div>' );
      //     '<div class="popup threedots"><span class="popuptext" id="myPopup"></span></div>'
      //   );
      // } else if (i === 1) {
      //   $(this).html('<div class="refresh"> </div>');
      // } else {
      //   $(this).html("");
      // }
    });

    $("#scrollabe-datatable-id thead").on("click", "th", function () {
      var row_index = table.column(this).index();

      if (row_index != undefined && row_index != 0) {
        var nRow = $("#scrollabe-datatable-id thead tr")[0];
        if (
          this.childNodes[0].className != "popup threedots" &&
          this.childNodes[0].className != "col-search ui-autocomplete-input" &&
          this.childNodes[0].className != "refresh"
        ) {
          nRow.childNodes.forEach(function (indx) {
            if (indx.cellIndex != row_index) {
              indx.className = "sorting_disabled";
            }
          });

          if (row_index) {
            if (this.className == "sorting_disabled") {
              this.className = "sorting_asc";
              var row;
              $.each(window.$mm_obligations_columnList, function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              });
              that.reloadData(
                1,
                window.$mm_obligations_result,
                row.shortType,
                "ASCENDING",
                row.shortField,
                window.$mm_obligations_filterContent
              );
            } else if (this.className == "sorting_asc") {
              this.className = "sorting_desc";
              var row;
              $.each(window.$mm_obligations_columnList, function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              });
              that.reloadData(
                1,
                window.$mm_obligations_result,
                row.shortType,
                "DESCENDING",
                row.shortField,
                window.$mm_obligations_filterContent
              );
            } else if (this.className == "sorting_desc") {
              this.className = "sorting_asc";
              var row;
              $.each(window.$mm_obligations_columnList, function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              });
              that.reloadData(
                1,
                window.$mm_obligations_result,
                row.shortType,
                "ASCENDING",
                row.shortField,
                window.$mm_obligations_filterContent
              );
            }
          }

          window.$mm_obligations_page_number = 1;
        }
      }
    });

    $("#example tbody").on("click", "tr", function () {
      if ($(".checkAll").attr("style") == "display: none;") {
        $(".checkNone, .checkAll").toggle();
      }
      DropFromSetSelectedButtonIdsIfSelected(this);
    });

    //** select all table
    $("#scrollabe-datatable-id").on("click", ".checkAll", function (e) {
      var table = $("#example").DataTable();
      table.rows().select();

      $(".checkNone, .checkAll").toggle();
    });

    //** unselect all table
    $("#scrollabe-datatable-id").on("click", ".checkNone", function (e) {
      var table = $("#example").DataTable();

      table.rows().deselect();
      $(".checkNone, .checkAll").toggle();
      window.$set_selected_button_selected_ids = []
    });

    $("#example_filter input").addClass("search-input-table1");
    $(".search-input-table1").attr("placeholder", "search text");

    $("#example tbody").on("dblclick", "tr", function () {
      // var rowId = this.attributes[1].value;
      var rowId = $(this).attr("rowId");

      $.each(window.$mm_obligations_Glist, function (index, data) {
        if (data.identification == rowId) {
          window.$mm_obligations_selectedRow = data;
          that.props.history.push(
            "/management-maintenance/obligations/detail/" + rowId,
            {
              rowData: data,
            }
          );
        }
      });

      // CommonFunctions.fillDetail();
      // $("#tableSide").addClass("d-none");
      // $("#detailSide").removeClass("d-none");
    });

    /*** ---OPTION TO ALLOW SELECTING ROWS BY CLICKING ON ROW BESIDES CHECKBOX--- ***/
    // $("#example tbody").on("click", "tr", function () {
    //   $(this).toggleClass("selected");
    // });

    $("#algemeen-code").autocomplete({
      source: window.$mm_obligations_filter_code,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-code", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-omschrijving").autocomplete({
      source: window.$mm_obligations_filter_omschrijving,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-omschrijving", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-boekingsnummer").autocomplete({
      source: window.$mm_obligations_filter_boekingsnummer,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-boekingsnummer", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-organisatie").autocomplete({
      source: window.$mm_obligations_filter_organisatie,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-organisatie", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-opdrachtgever").autocomplete({
      source: window.$mm_obligations_filter_opdrachtgever,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-opdrachtgever", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-directievoeder").autocomplete({
      source: window.$mm_obligations_filter_directievoeder,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-directievoeder", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-toezichthouder").autocomplete({
      source: window.$mm_obligations_filter_toezichthouder,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-toezichthouder", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-eenheid").autocomplete({
      source: window.$mm_obligations_filter_eenheid,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-eenheid", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-werkplan").autocomplete({
      source: window.$mm_obligations_filter_werkplan,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-werkplan", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-budget").autocomplete({
      source: window.$mm_obligations_filter_budget,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-budget", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-code").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-omschrijving").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-boekingsnummer").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-organisatie").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-opdrachtgever").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-directievoeder").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-toezichthouder").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-eenheid").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-werkplan").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-budget").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-naam").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });

    $(".col-search").on("input", function (e) {
      if (this.value === "") {
        that.addContentAndFillTable($(this).attr("id"), null);
      }
    });
    function handleRefresh () {
      $("#cover-spin").show(0);
      $("#spinner").removeAttr("hidden");
      that.fillTable(window.$mm_obligations_lastUsedTableFilter, 1);
      // that.reloadData(1);
    }
    window.$mm_obligations_refresh = handleRefresh;

    $(".refresh").click(handleRefresh);

    $("div.popup").click(function () {
      var test = this;
      var selectedIds = [];
      $("#example")
        .dataTable()
        .$("tr.selected")
        .each(function () {
          selectedIds.push($(this).attr("rowId"));
        });
      // that.setState({ selectedIds: selectedIds });
      window.$mm_obligations_selectedIds = selectedIds;
      that.GetActionsOfRow(selectedIds.join(","));
    });

    $(document).on("click", "#verwijderen", function () {
      if (window.$mm_obligations_selectedIds == 0) {
        alert("rows not selected");
      } else {
        $("#management-units-mappen_beheren_delete_modal").modal("show");
      }
    });

    function koppelAanFolderCallBack() {
      GC.sleep(2000).then(() => {
        $("#cover-spin").hide(0);

        $("#modal_koppel_aan_folder").modal("hide");
        that.reloadData(1);
      });
    }

    $(document).on("click", "#management-units-koppel-aan-folder", () => {
      $("#cover-spin").show(0);

      var model = {
        action: "ADD",
        contextRol: "Beheereenheid zit in folder",
        folder: document.getElementById("tree-parent-id").value,
      };
      GC.StartActivity(
        model,
        window.$mm_obligations_selectedIds,
        "708371ee-e3f6-4de7-87f8-dfe94b86f9b1",
        koppelAanFolderCallBack(),
        window.$mm_management_units_token
      );
    });

    $(document).on("click", ".mm_work_plans_action", function () {
      var actionId = $(this).attr("id");
      let modalId = window.$mm_work_plans_actions.filter(
        (act) => act["id"] === actionId
      )[0]["modal"];
      $("#" + modalId).modal("show");
    });
  }

  render() {
    return (
      <div id="tableSide">
        <table id="example" className="table-hover table min-full-width">
          <thead>
            <tr>
              {this.state.columnList}
              {/* <th className="sorting_disabled" style={{ width: "1%" }}>
                <span className="checkAll" />
                <span className="checkNone" style={{ display: "none" }} />
              </th>
              <th className="sorting_disabled" style={{ width: "1%" }}>
                <img
                  className="icon-table"
                  src={maatregelenSvg}
                  width={18}
                  height={18}
                />
              </th>
              <th>Code</th>
              <th>Omschrijving</th>
              <th>Boekingsnummer</th>
              <th>Datum aanvang</th>
              <th>Datum oplevering</th>
              <th>Organisatie</th>
              <th>Opdrachtgever</th>
              <th>Directievoeder</th>
              <th>Toezichthouder</th>
              <th>Eenheid</th>
              <th>Werkplan</th>
              <th>Budget</th> */}
            </tr>
          </thead>
          <tbody></tbody>
        </table>
        <input id="tree-parent-id" hidden />
        <input id="tree-parent-name" hidden />
      </div>
    );
  }
}

export default Table;
